module.exports = __webpack_public_path__ + "media/assets/images/flags/bw-2b6dcbb00bcc8fb2884adcb891ecc58d.svg";